import { unwrapResult } from "@reduxjs/toolkit";
import { Card, Col, Modal, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { ThemeContext } from "../../theme/theme";
import { getOrganizationDetailAsync } from "./OrganizationMessageSlice";

export const OrganizationDetailModal = (props: {
  id?: any;
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  const dispatch = useAppDispatch();

  const theme = useContext(ThemeContext);

  const [detail, setDetail] = useState<any>();

  useEffect(() => {
    if (props.id) {
      dispatch(getOrganizationDetailAsync(props.id))
        .then(unwrapResult)
        .then((d) => setDetail(d))
        .catch(() => {
          // do nothing
        });
    } else {
      setDetail(undefined);
    }
  }, [dispatch, props.id]);

  const labelStyle = {
    flex: "10rem",
    style: {
      color: theme.tc3,
      fontSize: "1rem",
      textAlign: "right",
      marginBottom: 8,
    } as React.CSSProperties,
  };

  const valueStyle = {
    flex: 1,
    style: {
      color: theme.tc1,
      fontSize: "1rem",
      marginBottom: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
    } as React.CSSProperties,
  };

  return (
    <>
      <Modal
        width={1200}
        title='机构详情'
        footer={null}
        visible={props.visible}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
      >
        <Card size='small' title='' style={{ marginBottom: '10px' }}>
          <Row gutter={20}>
            <Col span={12}>
              <Row wrap={false}>
                <Col {...labelStyle}>机构名称：</Col>
                <Col {...valueStyle}>{detail?.orgName}</Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row wrap={false}>
                <Col {...labelStyle}>机构简称：</Col>
                <Col {...valueStyle}>{detail?.orgAbbrName}</Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row wrap={false}>
                <Col {...labelStyle}>机构编码：</Col>
                <Col {...valueStyle}>{detail?.orgCode}</Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row wrap={false}>
                <Col {...labelStyle}>机构属性：</Col>
                <Col {...valueStyle}>
                  {detail && (detail.orgProperty === 0 ? '民营' : '公立')}
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row wrap={false}>
                <Col {...labelStyle}>所属卫健委(局)：</Col>
                <Col {...valueStyle}>{detail?.osName}</Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Modal>
    </>
  )
};
